const GoogleMaps = require('./../../../../../global/js/modules/google-maps'),
    VueUtils = require('../../../modules/vue-utils');


document.addEventListener('DOMContentLoaded', () => {

    if (!document.querySelector('html.my-account.register')) {
        return;
    }

    const $select = document.querySelector('.favourite-locations select');

    if (!$select) return;

    $select.addEventListener('change', event => {
        const $options = $select.querySelectorAll('option');

        if ($options.length === 0) {
            return;
        }

        let selected = 0, capped = false;
        for (const $option of $options) {
            if ($option.selected) {
                selected++;

                if (selected > 3) {
                    capped = true;
                    $option.selected = false;
                }
            }
        }

        if (capped) {
            const $dialog = VueUtils.getRef('modal-dialog');
            return $dialog.setContent('You can only select 3 locations', true);
        }

    });

});